import { Loader2 } from "lucide-react";

export const TicketDetailsLoading = () => (
  <div className="flex flex-col items-center justify-center gap-3 py-12">
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
    <p className="text-sm text-muted-foreground">Carregando...</p>
  </div>
);
